import { useEffect } from 'react';

const useKeyHandler = (
  isActive: boolean,
  handlers: Record<string, () => void>
): void => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent): void => {
      const action = handlers[e.key];
      if (action) {
        action();
      }
    };

    if (isActive) {
      window.addEventListener('keydown', handleKey);
    }

    return (): void => {
      if (isActive) {
        window.removeEventListener('keydown', handleKey);
      }
    };
  }, [isActive, handlers]);
};

export default useKeyHandler;
